import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ContractorsMeTimesheetsDownloadParams,
  PagedResultDto,
  Timesheet,
  TimesheetRequest
} from '@umss/shared/data-access';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimesheetService {
  private readonly apiUrl = '/api/Contractors/me/timesheets';

  constructor(private http: HttpClient) {}

  getAll(
    payload?: Partial<TimesheetRequest>
  ): Observable<PagedResultDto<Timesheet>> {
    const params = HttpHelper.toHttpParams(payload ?? {});
    return this.http.get<PagedResultDto<Timesheet>>(this.apiUrl, { params });
  }

  get(id: string): Observable<Timesheet> {
    return this.http.get<Timesheet>(`${this.apiUrl}/${id}`);
  }

  download(request?: ContractorsMeTimesheetsDownloadParams): Observable<Blob> {
    const params = HttpHelper.toHttpParams(request ?? {});
    return this.http.get(`${this.apiUrl}/download`, {
      responseType: 'blob',
      params
    });
  }
}
